// extracted by mini-css-extract-plugin
export default {"container":"ToastComponent_container__+JHL0","toast":"ToastComponent_toast__a+gKJ","closeBtn":"ToastComponent_closeBtn__sxGmz","more":"ToastComponent_more__lLbKM"};